import * as React from 'react';
import { Form, useFormApi } from 'informedv4';
import Modal from '../../misc/components/modal';
import Alert, { AlertCategoryEnum } from '../../misc/components/Alert';
import { DirectoryDialogForm, NewDirectoryDialogFormState, RenderCheckingIcon } from './DirectoryDialogForm';
import { Option } from "../../misc/OptionFormatters";

interface NewDirectoryDialogProps {
    roles: Option[];
    checkingDirectory: boolean;
    errorMessage: string;
    handleLinkClick: (directory: NewDirectoryDialogFormState) => void;
    handleCloseDialog: () => void;
}

export const NewDirectoryDialogForm = (props: NewDirectoryDialogProps) => {
    const formApi = useFormApi();

    const handleSubmit = () => {
        formApi.validate();
        const state = formApi.getFormState();

        if (state.invalid)
            return;

        props.handleLinkClick(state.values as unknown as NewDirectoryDialogFormState);
    }

    return (
        <div className="modal-body">
            <Alert show={props.errorMessage !== undefined} category={AlertCategoryEnum.Danger}>
                {props.errorMessage}
            </Alert>
                <DirectoryDialogForm roles={props.roles} />
                <div className="row">
                    <div className="form-group">
                        <div className="col-sm-4">
                        <button className="btn btn-primary" type="submit" onClick={handleSubmit}>Link</button>
                        </div>
                    </div>
                </div>
            <div className="row">
                <div className="col-md-12">
                    {RenderCheckingIcon(props.checkingDirectory)}
                </div>
            </div>
        </div>
    );
}

export const NewDirectoryDialog = (props: NewDirectoryDialogProps) => {
    return (
        <Modal header="New Directory" show={true} closeModalHandler={props.handleCloseDialog}>
            <Form validateOn="submit">
                <NewDirectoryDialogForm {...props} />
            </Form>
        </Modal>
    );
}
